export default __webpack_public_path__ + "static/media/horizontalBar.6325dbed.svg";